/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { AdjustmentInquiryRequestInfo } from '../model/adjustmentInquiryRequestInfo';
import { AdjustmentInquiryResponseInfo } from '../model/adjustmentInquiryResponseInfo';
import { AdjustmentRequestInfo } from '../model/adjustmentRequestInfo';
import { AdjustmentResponseInfo } from '../model/adjustmentResponseInfo';
import { AdminInfo3 } from '../model/adminInfo3';
import { ConsumerRegistrationRequestInfo } from '../model/consumerRegistrationRequestInfo';
import { ConsumerRegistrationResponseInfo } from '../model/consumerRegistrationResponseInfo';
import { DetectNetworkResponse } from '../model/detectNetworkResponse';
import { EnrolledResponse } from '../model/enrolledResponse';
import { ErrorMessage } from '../model/errorMessage';
import { GatewayActPmtMethodRequestInfo } from '../model/gatewayActPmtMethodRequestInfo';
import { GatewayActPmtMethodResponseInfo } from '../model/gatewayActPmtMethodResponseInfo';
import { GatewayActPmtMethodResponseInfo2 } from '../model/gatewayActPmtMethodResponseInfo2';
import { GatewayActPmtMethodResponseInfoList } from '../model/gatewayActPmtMethodResponseInfoList';
import { GatewayActPmtMethodResponseInfoList2 } from '../model/gatewayActPmtMethodResponseInfoList2';
import { GatewayActPmtMethodUpdateRequestInfo } from '../model/gatewayActPmtMethodUpdateRequestInfo';
import { GatewayPaymentMethodResponseInfo } from '../model/gatewayPaymentMethodResponseInfo';
import { GatewayProcessorResponseInfo } from '../model/gatewayProcessorResponseInfo';
import { GatewayRoutingRequestInfo } from '../model/gatewayRoutingRequestInfo';
import { GatewayRoutingResponseInfo } from '../model/gatewayRoutingResponseInfo';
import { GatewayRoutingResponseInfoList } from '../model/gatewayRoutingResponseInfoList';
import { GatewayRoutingResponseInfoList2 } from '../model/gatewayRoutingResponseInfoList2';
import { GatewaySettingResponseInfo } from '../model/gatewaySettingResponseInfo';
import { InlineResponse20010 } from '../model/inlineResponse20010';
import { InlineResponse2008 } from '../model/inlineResponse2008';
import { InlineResponse2009 } from '../model/inlineResponse2009';
import { InlineResponse400 } from '../model/inlineResponse400';
import { InlineResponse401 } from '../model/inlineResponse401';
import { LocalDeviceRequest } from '../model/localDeviceRequest';
import { LocalDeviceResponse } from '../model/localDeviceResponse';
import { NetworkDevicePingRequest } from '../model/networkDevicePingRequest';
import { NetworkDevicePingResponse } from '../model/networkDevicePingResponse';
import { NotificationReceiptRequestInfo } from '../model/notificationReceiptRequestInfo';
import { NotificationReceiptResponseInfo } from '../model/notificationReceiptResponseInfo';
import { NotificationSendRequestInfo } from '../model/notificationSendRequestInfo';
import { NotificationSendResponseInfo } from '../model/notificationSendResponseInfo';
import { OrgPaymentMethodCreateRequestInfo } from '../model/orgPaymentMethodCreateRequestInfo';
import { OrgPaymentMethodResponseInfo } from '../model/orgPaymentMethodResponseInfo';
import { PaymentAgreementCancelRequest } from '../model/paymentAgreementCancelRequest';
import { PaymentAgreementCancelResponse } from '../model/paymentAgreementCancelResponse';
import { PaymentAgreementRequestInfo } from '../model/paymentAgreementRequestInfo';
import { PaymentAgreementRequestInfo2 } from '../model/paymentAgreementRequestInfo2';
import { PaymentAgreementResponseInfo } from '../model/paymentAgreementResponseInfo';
import { PaymentAgreementResponseInfo2 } from '../model/paymentAgreementResponseInfo2';
import { PaymentAgreementRetrieveInfo } from '../model/paymentAgreementRetrieveInfo';
import { PaymentInfoResponseInfo } from '../model/paymentInfoResponseInfo';
import { PaymentInquiryRequestInfo } from '../model/paymentInquiryRequestInfo';
import { PaymentInquiryResponseInfo } from '../model/paymentInquiryResponseInfo';
import { PaymentMethodInquiryRequestInfo } from '../model/paymentMethodInquiryRequestInfo';
import { PaymentMethodInquiryResponseInfo } from '../model/paymentMethodInquiryResponseInfo';
import { PaymentMethodResponseInfo } from '../model/paymentMethodResponseInfo';
import { PaymentPlanCalCreateRequest } from '../model/paymentPlanCalCreateRequest';
import { PaymentPlanCalCreateResponse } from '../model/paymentPlanCalCreateResponse';
import { PaymentPlanCancelResponse } from '../model/paymentPlanCancelResponse';
import { PaymentRequestInfo } from '../model/paymentRequestInfo';
import { PaymentResponseInfo } from '../model/paymentResponseInfo';
import { PaymentRetryRequestInfo } from '../model/paymentRetryRequestInfo';
import { PaymentRetryResponseInfo } from '../model/paymentRetryResponseInfo';
import { PlanOptionsRequest } from '../model/planOptionsRequest';
import { PlanOptionsResponse } from '../model/planOptionsResponse';
import { ProcessPaymentRequestInfo } from '../model/processPaymentRequestInfo';
import { ProcessPaymentResponseInfo } from '../model/processPaymentResponseInfo';
import { Request7 } from '../model/request7';
import { Request8 } from '../model/request8';
import { Request9 } from '../model/request9';
import { SummaryResponse } from '../model/summaryResponse';
import { TransactionHistoryResponseInfo } from '../model/transactionHistoryResponseInfo';
import { TransactionResponse } from '../model/transactionResponse';
import { TransactionResponse2 } from '../model/transactionResponse2';
import { UpcomingScheduleRetrieveResponseInfo } from '../model/upcomingScheduleRetrieveResponseInfo';
import { WalletCreateRequest } from '../model/walletCreateRequest';
import { WalletCreateResponse } from '../model/walletCreateResponse';
import { WalletGetResponse } from '../model/walletGetResponse';
import { WalletRetrieveResponse } from '../model/walletRetrieveResponse';
import { WalletUpdateRequest } from '../model/walletUpdateRequest';
import { WalletUpdateResponse } from '../model/walletUpdateResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PmtMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * PmtMgr_AdminInfo, Get the Admin Info
     * Gives the latest Version Control and Host Info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1AdminInfoGet(observe?: 'body', reportProgress?: boolean): Observable<AdminInfo3>;
    public pmtMgrV1AdminInfoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminInfo3>>;
    public pmtMgrV1AdminInfoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminInfo3>>;
    public pmtMgrV1AdminInfoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AdminInfo3>(`${this.basePath}/PmtMgr/V1/Admin/Info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_ConsumerEnrolledPlanLineItem, Ability to return Plan enrolled AccountNumbers
     * Ability to return Plan enrolled AccountNumbers
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1ConsumerEnrolledPlanLineItemsGet(OrgId: number, ConsumerNumber: string, observe?: 'body', reportProgress?: boolean): Observable<EnrolledResponse>;
    public pmtMgrV1ConsumerEnrolledPlanLineItemsGet(OrgId: number, ConsumerNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EnrolledResponse>>;
    public pmtMgrV1ConsumerEnrolledPlanLineItemsGet(OrgId: number, ConsumerNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EnrolledResponse>>;
    public pmtMgrV1ConsumerEnrolledPlanLineItemsGet(OrgId: number, ConsumerNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1ConsumerEnrolledPlanLineItemsGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1ConsumerEnrolledPlanLineItemsGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<EnrolledResponse>(`${this.basePath}/PmtMgr/V1/Consumer/Enrolled/PlanLineItems`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentPlanOptions, Ability to return payment plan options
     * Ability to return payment plan options
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter template specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1ConsumerPaymentPlanOptionsDataPost(OrgId: number, ConsumerNumber: string, Request: PlanOptionsRequest, observe?: 'body', reportProgress?: boolean): Observable<PlanOptionsResponse>;
    public pmtMgrV1ConsumerPaymentPlanOptionsDataPost(OrgId: number, ConsumerNumber: string, Request: PlanOptionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlanOptionsResponse>>;
    public pmtMgrV1ConsumerPaymentPlanOptionsDataPost(OrgId: number, ConsumerNumber: string, Request: PlanOptionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlanOptionsResponse>>;
    public pmtMgrV1ConsumerPaymentPlanOptionsDataPost(OrgId: number, ConsumerNumber: string, Request: PlanOptionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1ConsumerPaymentPlanOptionsDataPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1ConsumerPaymentPlanOptionsDataPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1ConsumerPaymentPlanOptionsDataPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PlanOptionsResponse>(`${this.basePath}/PmtMgr/V1/Consumer/PaymentPlanOptions/Data`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_ConsumerPlan, Get the Payment Info for consumer portal
     * Get the Payment Plan Info based on OrgId and ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param PlanId Enter the PlanId
     * @param Status Enter the Status. Allowed values are Open or All. Open is default. When Status is All, it retruns data of all statuses of Plan.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1ConsumerPlanGet(OrgId: number, ConsumerNumber: string, PlanId?: number, Status?: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse20010>;
    public pmtMgrV1ConsumerPlanGet(OrgId: number, ConsumerNumber: string, PlanId?: number, Status?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse20010>>;
    public pmtMgrV1ConsumerPlanGet(OrgId: number, ConsumerNumber: string, PlanId?: number, Status?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse20010>>;
    public pmtMgrV1ConsumerPlanGet(OrgId: number, ConsumerNumber: string, PlanId?: number, Status?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1ConsumerPlanGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1ConsumerPlanGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (PlanId !== undefined) {
            queryParameters = queryParameters.set('PlanId', <any>PlanId);
        }
        if (Status !== undefined) {
            queryParameters = queryParameters.set('Status', <any>Status);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<InlineResponse20010>(`${this.basePath}/PmtMgr/V1/Consumer/Plan`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrievePlanSummary, Get the summary info for a plan
     * Get the summary info for a plan
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param PlanId Enter the PlanId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1ConsumerPlanPlanIdSummaryGet(OrgId: number, ConsumerNumber: string, PlanId: number, observe?: 'body', reportProgress?: boolean): Observable<SummaryResponse>;
    public pmtMgrV1ConsumerPlanPlanIdSummaryGet(OrgId: number, ConsumerNumber: string, PlanId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummaryResponse>>;
    public pmtMgrV1ConsumerPlanPlanIdSummaryGet(OrgId: number, ConsumerNumber: string, PlanId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummaryResponse>>;
    public pmtMgrV1ConsumerPlanPlanIdSummaryGet(OrgId: number, ConsumerNumber: string, PlanId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1ConsumerPlanPlanIdSummaryGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1ConsumerPlanPlanIdSummaryGet.');
        }
        if (PlanId === null || PlanId === undefined) {
            throw new Error('Required parameter PlanId was null or undefined when calling pmtMgrV1ConsumerPlanPlanIdSummaryGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SummaryResponse>(`${this.basePath}/PmtMgr/V1/Consumer/Plan/${encodeURIComponent(String(PlanId))}/Summary`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_ConsumerRegistration, Create Consumer Registration
     * Create Consumer Registration
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param FacilityId Enter the FacilityId
     * @param DeptId Enter the DeptId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1ConsumerRegistrationPost(OrgId: number, ConsumerNumber: string, Request: ConsumerRegistrationRequestInfo, FacilityId?: number, DeptId?: number, observe?: 'body', reportProgress?: boolean): Observable<ConsumerRegistrationResponseInfo>;
    public pmtMgrV1ConsumerRegistrationPost(OrgId: number, ConsumerNumber: string, Request: ConsumerRegistrationRequestInfo, FacilityId?: number, DeptId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConsumerRegistrationResponseInfo>>;
    public pmtMgrV1ConsumerRegistrationPost(OrgId: number, ConsumerNumber: string, Request: ConsumerRegistrationRequestInfo, FacilityId?: number, DeptId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConsumerRegistrationResponseInfo>>;
    public pmtMgrV1ConsumerRegistrationPost(OrgId: number, ConsumerNumber: string, Request: ConsumerRegistrationRequestInfo, FacilityId?: number, DeptId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1ConsumerRegistrationPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1ConsumerRegistrationPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1ConsumerRegistrationPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (DeptId !== undefined && DeptId !== null) {
            headers = headers.set('DeptId', String(DeptId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerRegistrationResponseInfo>(`${this.basePath}/PmtMgr/V1/Consumer/Registration`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveTransactionInfo, Get the Transaction Info
     * Get the Transaction Info
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param BundleTransactionId Enter the BundleTransactionId
     * @param PlanId Enter the PlanId
     * @param TransactionId Enter the TransactionId
     * @param ParentTransactionId Enter the ParentTransactionId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1ConsumerTransactionGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, PlanId?: number, TransactionId?: number, ParentTransactionId?: number, observe?: 'body', reportProgress?: boolean): Observable<TransactionResponse2>;
    public pmtMgrV1ConsumerTransactionGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, PlanId?: number, TransactionId?: number, ParentTransactionId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionResponse2>>;
    public pmtMgrV1ConsumerTransactionGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, PlanId?: number, TransactionId?: number, ParentTransactionId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionResponse2>>;
    public pmtMgrV1ConsumerTransactionGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, PlanId?: number, TransactionId?: number, ParentTransactionId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1ConsumerTransactionGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1ConsumerTransactionGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (BundleTransactionId !== undefined) {
            queryParameters = queryParameters.set('BundleTransactionId', <any>BundleTransactionId);
        }
        if (PlanId !== undefined) {
            queryParameters = queryParameters.set('PlanId', <any>PlanId);
        }
        if (TransactionId !== undefined) {
            queryParameters = queryParameters.set('TransactionId', <any>TransactionId);
        }
        if (ParentTransactionId !== undefined) {
            queryParameters = queryParameters.set('ParentTransactionId', <any>ParentTransactionId);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<TransactionResponse2>(`${this.basePath}/PmtMgr/V1/Consumer/Transaction`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_DeleteGatewayAct, Delete a Gateway Account
     * Delete a Gateway Account
     * @param GroupId Enter the GroupId
     * @param GatewayAccountId Enter the GatewayAccountId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayAccountGatewayAccountIdDelete(GroupId: string, GatewayAccountId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pmtMgrV1GatewayAccountGatewayAccountIdDelete(GroupId: string, GatewayAccountId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pmtMgrV1GatewayAccountGatewayAccountIdDelete(GroupId: string, GatewayAccountId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pmtMgrV1GatewayAccountGatewayAccountIdDelete(GroupId: string, GatewayAccountId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1GatewayAccountGatewayAccountIdDelete.');
        }
        if (GatewayAccountId === null || GatewayAccountId === undefined) {
            throw new Error('Required parameter GatewayAccountId was null or undefined when calling pmtMgrV1GatewayAccountGatewayAccountIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/PmtMgr/V1/GatewayAccount/${encodeURIComponent(String(GatewayAccountId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_UpdateGatewayAct, Update a Gateway Account
     * Update a Gateway Account
     * @param GroupId Enter the GroupId
     * @param GatewayAccountId Enter the GatewayAccountId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayAccountGatewayAccountIdPut(GroupId: string, GatewayAccountId: string, Request: GatewayActPmtMethodUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<GatewayActPmtMethodResponseInfo2>;
    public pmtMgrV1GatewayAccountGatewayAccountIdPut(GroupId: string, GatewayAccountId: string, Request: GatewayActPmtMethodUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayActPmtMethodResponseInfo2>>;
    public pmtMgrV1GatewayAccountGatewayAccountIdPut(GroupId: string, GatewayAccountId: string, Request: GatewayActPmtMethodUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayActPmtMethodResponseInfo2>>;
    public pmtMgrV1GatewayAccountGatewayAccountIdPut(GroupId: string, GatewayAccountId: string, Request: GatewayActPmtMethodUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1GatewayAccountGatewayAccountIdPut.');
        }
        if (GatewayAccountId === null || GatewayAccountId === undefined) {
            throw new Error('Required parameter GatewayAccountId was null or undefined when calling pmtMgrV1GatewayAccountGatewayAccountIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1GatewayAccountGatewayAccountIdPut.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<GatewayActPmtMethodResponseInfo2>(`${this.basePath}/PmtMgr/V1/GatewayAccount/${encodeURIComponent(String(GatewayAccountId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveGatewayAct, Get the Gateway Account based on GroupId
     * Get the Gateway Account based on GroupId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayAccountGet(GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<GatewayActPmtMethodResponseInfoList>;
    public pmtMgrV1GatewayAccountGet(GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayActPmtMethodResponseInfoList>>;
    public pmtMgrV1GatewayAccountGet(GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayActPmtMethodResponseInfoList>>;
    public pmtMgrV1GatewayAccountGet(GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1GatewayAccountGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewayActPmtMethodResponseInfoList>(`${this.basePath}/PmtMgr/V1/GatewayAccount`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_CreateGatewayAct, Create a Gateway Account
     * Create a Gateway Account
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayAccountPost(GroupId: string, Request: GatewayActPmtMethodRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<GatewayActPmtMethodResponseInfo>;
    public pmtMgrV1GatewayAccountPost(GroupId: string, Request: GatewayActPmtMethodRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayActPmtMethodResponseInfo>>;
    public pmtMgrV1GatewayAccountPost(GroupId: string, Request: GatewayActPmtMethodRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayActPmtMethodResponseInfo>>;
    public pmtMgrV1GatewayAccountPost(GroupId: string, Request: GatewayActPmtMethodRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1GatewayAccountPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1GatewayAccountPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<GatewayActPmtMethodResponseInfo>(`${this.basePath}/PmtMgr/V1/GatewayAccount`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_SearchGatewayAct, Search the Gateway Account based on OrgId and Name
     * Search the Gateway Account based on OrgId and Name
     * @param GroupId Enter the GroupId
     * @param GatewayAccountName Enter the GatewayAccountName
     * @param SearchType Enter the SearchType. Allowed values are Equals, Contains, StartsWith, EndsWith
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayAccountSearchGet(GroupId: number, GatewayAccountName: string, SearchType?: string, observe?: 'body', reportProgress?: boolean): Observable<GatewayActPmtMethodResponseInfoList2>;
    public pmtMgrV1GatewayAccountSearchGet(GroupId: number, GatewayAccountName: string, SearchType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayActPmtMethodResponseInfoList2>>;
    public pmtMgrV1GatewayAccountSearchGet(GroupId: number, GatewayAccountName: string, SearchType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayActPmtMethodResponseInfoList2>>;
    public pmtMgrV1GatewayAccountSearchGet(GroupId: number, GatewayAccountName: string, SearchType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1GatewayAccountSearchGet.');
        }
        if (GatewayAccountName === null || GatewayAccountName === undefined) {
            throw new Error('Required parameter GatewayAccountName was null or undefined when calling pmtMgrV1GatewayAccountSearchGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (GatewayAccountName !== undefined) {
            queryParameters = queryParameters.set('GatewayAccountName', <any>GatewayAccountName);
        }
        if (SearchType !== undefined) {
            queryParameters = queryParameters.set('SearchType', <any>SearchType);
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewayActPmtMethodResponseInfoList2>(`${this.basePath}/PmtMgr/V1/GatewayAccount/Search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveGatewayPmtMethod, Get the Gateway Payment Methods
     * Get the Gateway Payment Methods based on GatewayName
     * @param GatewayName Enter the GatewayName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayPaymentMethodGet(GatewayName: string, observe?: 'body', reportProgress?: boolean): Observable<GatewayPaymentMethodResponseInfo>;
    public pmtMgrV1GatewayPaymentMethodGet(GatewayName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayPaymentMethodResponseInfo>>;
    public pmtMgrV1GatewayPaymentMethodGet(GatewayName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayPaymentMethodResponseInfo>>;
    public pmtMgrV1GatewayPaymentMethodGet(GatewayName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GatewayName === null || GatewayName === undefined) {
            throw new Error('Required parameter GatewayName was null or undefined when calling pmtMgrV1GatewayPaymentMethodGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (GatewayName !== undefined) {
            queryParameters = queryParameters.set('GatewayName', <any>GatewayName);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewayPaymentMethodResponseInfo>(`${this.basePath}/PmtMgr/V1/Gateway/PaymentMethod`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveAllGatewayProc, Get all Gateway Processor
     * Get all Gateway Processor
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayProcessorGet(observe?: 'body', reportProgress?: boolean): Observable<GatewayProcessorResponseInfo>;
    public pmtMgrV1GatewayProcessorGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayProcessorResponseInfo>>;
    public pmtMgrV1GatewayProcessorGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayProcessorResponseInfo>>;
    public pmtMgrV1GatewayProcessorGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewayProcessorResponseInfo>(`${this.basePath}/PmtMgr/V1/GatewayProcessor`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_GatewayRoutingAssigned, Get the Gateway Routing based on GroupId and GatewayRoutingCode
     * Get the Gateway Routing based on GroupId and GatewayRoutingCode
     * @param GroupId Enter the GroupId
     * @param GatewayRoutingCode Enter the GatewayRoutingCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayRoutingAssignedGet(GroupId: number, GatewayRoutingCode: string, observe?: 'body', reportProgress?: boolean): Observable<GatewayRoutingResponseInfoList2>;
    public pmtMgrV1GatewayRoutingAssignedGet(GroupId: number, GatewayRoutingCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayRoutingResponseInfoList2>>;
    public pmtMgrV1GatewayRoutingAssignedGet(GroupId: number, GatewayRoutingCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayRoutingResponseInfoList2>>;
    public pmtMgrV1GatewayRoutingAssignedGet(GroupId: number, GatewayRoutingCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1GatewayRoutingAssignedGet.');
        }
        if (GatewayRoutingCode === null || GatewayRoutingCode === undefined) {
            throw new Error('Required parameter GatewayRoutingCode was null or undefined when calling pmtMgrV1GatewayRoutingAssignedGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (GatewayRoutingCode !== undefined) {
            queryParameters = queryParameters.set('GatewayRoutingCode', <any>GatewayRoutingCode);
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewayRoutingResponseInfoList2>(`${this.basePath}/PmtMgr/V1/GatewayRouting/Assigned`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_DeleteGatewayRouting, Delete a Gateway Routing
     * Delete a Gateway Routing
     * @param OrgId Enter the OrgId
     * @param GatewayAccountId Enter the Gateway Account Id
     * @param PaymentMethod Enter the PaymentMethod. Allowed values are Card and ACH
     * @param Type Enter the Type. Allowed values are Amount and Fee
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayRoutingDelete(OrgId: string, GatewayAccountId: number, PaymentMethod: string, Type: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pmtMgrV1GatewayRoutingDelete(OrgId: string, GatewayAccountId: number, PaymentMethod: string, Type: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pmtMgrV1GatewayRoutingDelete(OrgId: string, GatewayAccountId: number, PaymentMethod: string, Type: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pmtMgrV1GatewayRoutingDelete(OrgId: string, GatewayAccountId: number, PaymentMethod: string, Type: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1GatewayRoutingDelete.');
        }
        if (GatewayAccountId === null || GatewayAccountId === undefined) {
            throw new Error('Required parameter GatewayAccountId was null or undefined when calling pmtMgrV1GatewayRoutingDelete.');
        }
        if (PaymentMethod === null || PaymentMethod === undefined) {
            throw new Error('Required parameter PaymentMethod was null or undefined when calling pmtMgrV1GatewayRoutingDelete.');
        }
        if (Type === null || Type === undefined) {
            throw new Error('Required parameter Type was null or undefined when calling pmtMgrV1GatewayRoutingDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (GatewayAccountId !== undefined) {
            queryParameters = queryParameters.set('GatewayAccountId', <any>GatewayAccountId);
        }
        if (PaymentMethod !== undefined) {
            queryParameters = queryParameters.set('PaymentMethod', <any>PaymentMethod);
        }
        if (Type !== undefined) {
            queryParameters = queryParameters.set('Type', <any>Type);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/PmtMgr/V1/GatewayRouting`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveGatewayRouting, Get the Gateway Routing based on OrgId
     * Get the Gateway Routing based on OrgId
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayRoutingGet(OrgId: number, observe?: 'body', reportProgress?: boolean): Observable<GatewayRoutingResponseInfoList>;
    public pmtMgrV1GatewayRoutingGet(OrgId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayRoutingResponseInfoList>>;
    public pmtMgrV1GatewayRoutingGet(OrgId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayRoutingResponseInfoList>>;
    public pmtMgrV1GatewayRoutingGet(OrgId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1GatewayRoutingGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewayRoutingResponseInfoList>(`${this.basePath}/PmtMgr/V1/GatewayRouting`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_AssignGatewayRouting, Create/Update a Gateway Routing
     * Create a Gateway Routing
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewayRoutingPost(OrgId: string, Request: GatewayRoutingRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<GatewayRoutingResponseInfo>;
    public pmtMgrV1GatewayRoutingPost(OrgId: string, Request: GatewayRoutingRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayRoutingResponseInfo>>;
    public pmtMgrV1GatewayRoutingPost(OrgId: string, Request: GatewayRoutingRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayRoutingResponseInfo>>;
    public pmtMgrV1GatewayRoutingPost(OrgId: string, Request: GatewayRoutingRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1GatewayRoutingPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1GatewayRoutingPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<GatewayRoutingResponseInfo>(`${this.basePath}/PmtMgr/V1/GatewayRouting`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveGatewaySetting, Get Gateway Setting
     * Get Gateway Setting by ProcessorName and GatewayName
     * @param ProcessorName Enter the Processor Name
     * @param GatewayName Enter the Gateway Name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1GatewaySettingGet(ProcessorName: string, GatewayName: string, observe?: 'body', reportProgress?: boolean): Observable<GatewaySettingResponseInfo>;
    public pmtMgrV1GatewaySettingGet(ProcessorName: string, GatewayName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewaySettingResponseInfo>>;
    public pmtMgrV1GatewaySettingGet(ProcessorName: string, GatewayName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewaySettingResponseInfo>>;
    public pmtMgrV1GatewaySettingGet(ProcessorName: string, GatewayName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ProcessorName === null || ProcessorName === undefined) {
            throw new Error('Required parameter ProcessorName was null or undefined when calling pmtMgrV1GatewaySettingGet.');
        }
        if (GatewayName === null || GatewayName === undefined) {
            throw new Error('Required parameter GatewayName was null or undefined when calling pmtMgrV1GatewaySettingGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ProcessorName !== undefined) {
            queryParameters = queryParameters.set('ProcessorName', <any>ProcessorName);
        }
        if (GatewayName !== undefined) {
            queryParameters = queryParameters.set('GatewayName', <any>GatewayName);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewaySettingResponseInfo>(`${this.basePath}/PmtMgr/V1/GatewaySetting`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_LocalDeviceRequest, Find local device request
     * Find local device request
     * @param GroupId Enter the GroupId
     * @param ConsumerNumber Enter consumer number
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1LocalDeviceRequestPost(GroupId: number, ConsumerNumber: string, Request: LocalDeviceRequest, observe?: 'body', reportProgress?: boolean): Observable<LocalDeviceResponse>;
    public pmtMgrV1LocalDeviceRequestPost(GroupId: number, ConsumerNumber: string, Request: LocalDeviceRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LocalDeviceResponse>>;
    public pmtMgrV1LocalDeviceRequestPost(GroupId: number, ConsumerNumber: string, Request: LocalDeviceRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LocalDeviceResponse>>;
    public pmtMgrV1LocalDeviceRequestPost(GroupId: number, ConsumerNumber: string, Request: LocalDeviceRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1LocalDeviceRequestPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1LocalDeviceRequestPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1LocalDeviceRequestPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<LocalDeviceResponse>(`${this.basePath}/PmtMgr/V1/Local/Device/Request`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_NetworkDevicePing, Ping a network device
     * Ping a network device
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1NetworkDevicePingPost(GroupId: number, Request: NetworkDevicePingRequest, observe?: 'body', reportProgress?: boolean): Observable<NetworkDevicePingResponse>;
    public pmtMgrV1NetworkDevicePingPost(GroupId: number, Request: NetworkDevicePingRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkDevicePingResponse>>;
    public pmtMgrV1NetworkDevicePingPost(GroupId: number, Request: NetworkDevicePingRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkDevicePingResponse>>;
    public pmtMgrV1NetworkDevicePingPost(GroupId: number, Request: NetworkDevicePingRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling pmtMgrV1NetworkDevicePingPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1NetworkDevicePingPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NetworkDevicePingResponse>(`${this.basePath}/PmtMgr/V1/Network/Device/Ping`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveAllOrgPmtMethod, Get the Org Payment Methods
     * Get the Org Payment Methods
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1OrgPaymentMethodGet(OrgId: string, observe?: 'body', reportProgress?: boolean): Observable<OrgPaymentMethodResponseInfo>;
    public pmtMgrV1OrgPaymentMethodGet(OrgId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrgPaymentMethodResponseInfo>>;
    public pmtMgrV1OrgPaymentMethodGet(OrgId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrgPaymentMethodResponseInfo>>;
    public pmtMgrV1OrgPaymentMethodGet(OrgId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1OrgPaymentMethodGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<OrgPaymentMethodResponseInfo>(`${this.basePath}/PmtMgr/V1/Org/PaymentMethod`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_CreateOrgPmtMethod, Assign Payment Method to a Org
     * Assign(Create or delete) Payment Method to a Org
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1OrgPaymentMethodPost(OrgId: string, Request: OrgPaymentMethodCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<OrgPaymentMethodResponseInfo>;
    public pmtMgrV1OrgPaymentMethodPost(OrgId: string, Request: OrgPaymentMethodCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrgPaymentMethodResponseInfo>>;
    public pmtMgrV1OrgPaymentMethodPost(OrgId: string, Request: OrgPaymentMethodCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrgPaymentMethodResponseInfo>>;
    public pmtMgrV1OrgPaymentMethodPost(OrgId: string, Request: OrgPaymentMethodCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1OrgPaymentMethodPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1OrgPaymentMethodPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<OrgPaymentMethodResponseInfo>(`${this.basePath}/PmtMgr/V1/Org/PaymentMethod`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_AdjustmentInquiry, Inquiry about transaction
     * This api returns information about a particular transaction
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentAdjustmentInquiryPost(OrgId: number, Request: AdjustmentInquiryRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<AdjustmentInquiryResponseInfo>;
    public pmtMgrV1PaymentAdjustmentInquiryPost(OrgId: number, Request: AdjustmentInquiryRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdjustmentInquiryResponseInfo>>;
    public pmtMgrV1PaymentAdjustmentInquiryPost(OrgId: number, Request: AdjustmentInquiryRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdjustmentInquiryResponseInfo>>;
    public pmtMgrV1PaymentAdjustmentInquiryPost(OrgId: number, Request: AdjustmentInquiryRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentAdjustmentInquiryPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentAdjustmentInquiryPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<AdjustmentInquiryResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Adjustment/Inquiry`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_Adjustment, Adjusting a transaction
     * This api Void/Refund a transaction
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentAdjustmentPost(OrgId: number, Request: AdjustmentRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<AdjustmentResponseInfo>;
    public pmtMgrV1PaymentAdjustmentPost(OrgId: number, Request: AdjustmentRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdjustmentResponseInfo>>;
    public pmtMgrV1PaymentAdjustmentPost(OrgId: number, Request: AdjustmentRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdjustmentResponseInfo>>;
    public pmtMgrV1PaymentAdjustmentPost(OrgId: number, Request: AdjustmentRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentAdjustmentPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentAdjustmentPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<AdjustmentResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Adjustment`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_CancelPaymentAgreement, Cancel a Payment Agreement
     * Cancel a Payment Agreement
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Id Enter the PaymentAgreement Id
     * @param Request Enter the request values
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentAgreementIdCancelPost(OrgId: number, ConsumerNumber: string, Id: number, Request: PaymentAgreementCancelRequest, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaymentAgreementCancelResponse>;
    public pmtMgrV1PaymentAgreementIdCancelPost(OrgId: number, ConsumerNumber: string, Id: number, Request: PaymentAgreementCancelRequest, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentAgreementCancelResponse>>;
    public pmtMgrV1PaymentAgreementIdCancelPost(OrgId: number, ConsumerNumber: string, Id: number, Request: PaymentAgreementCancelRequest, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentAgreementCancelResponse>>;
    public pmtMgrV1PaymentAgreementIdCancelPost(OrgId: number, ConsumerNumber: string, Id: number, Request: PaymentAgreementCancelRequest, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentAgreementIdCancelPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentAgreementIdCancelPost.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling pmtMgrV1PaymentAgreementIdCancelPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentAgreementIdCancelPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentAgreementCancelResponse>(`${this.basePath}/PmtMgr/V1/PaymentAgreement/${encodeURIComponent(String(Id))}/Cancel`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_UpdatePaymentAgreement, Update a Payment Agreement
     * Update a Payment Agreement
     * @param Id Enter the Id
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentAgreementIdPut(Id: number, OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo2, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaymentAgreementResponseInfo2>;
    public pmtMgrV1PaymentAgreementIdPut(Id: number, OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo2, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentAgreementResponseInfo2>>;
    public pmtMgrV1PaymentAgreementIdPut(Id: number, OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo2, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentAgreementResponseInfo2>>;
    public pmtMgrV1PaymentAgreementIdPut(Id: number, OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo2, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling pmtMgrV1PaymentAgreementIdPut.');
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentAgreementIdPut.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentAgreementIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentAgreementIdPut.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<PaymentAgreementResponseInfo2>(`${this.basePath}/PmtMgr/V1/PaymentAgreement/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentAgreementRetrieveById, Retrieve Payment Agreement
     * Retrieve Payment Agreement
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Id Enter the PaymentAgreement Id
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentAgreementIdRetrieveGet(OrgId: number, ConsumerNumber: string, Id: number, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaymentAgreementRetrieveInfo>;
    public pmtMgrV1PaymentAgreementIdRetrieveGet(OrgId: number, ConsumerNumber: string, Id: number, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentAgreementRetrieveInfo>>;
    public pmtMgrV1PaymentAgreementIdRetrieveGet(OrgId: number, ConsumerNumber: string, Id: number, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentAgreementRetrieveInfo>>;
    public pmtMgrV1PaymentAgreementIdRetrieveGet(OrgId: number, ConsumerNumber: string, Id: number, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentAgreementIdRetrieveGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentAgreementIdRetrieveGet.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling pmtMgrV1PaymentAgreementIdRetrieveGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<PaymentAgreementRetrieveInfo>(`${this.basePath}/PmtMgr/V1/PaymentAgreement/${encodeURIComponent(String(Id))}/Retrieve`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentAgreement, Create a Payment Agreement
     * Create a Payment Agreement
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentAgreementPost(OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaymentAgreementResponseInfo>;
    public pmtMgrV1PaymentAgreementPost(OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentAgreementResponseInfo>>;
    public pmtMgrV1PaymentAgreementPost(OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentAgreementResponseInfo>>;
    public pmtMgrV1PaymentAgreementPost(OrgId: number, ConsumerNumber: string, Request: PaymentAgreementRequestInfo, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentAgreementPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentAgreementPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentAgreementPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentAgreementResponseInfo>(`${this.basePath}/PmtMgr/V1/PaymentAgreement`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentAgreementRetrieve, Retrieve Payment Agreement
     * Retrieve Payment Agreement
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentAgreementRetrieveGet(OrgId: number, ConsumerNumber: string, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaymentAgreementRetrieveInfo>;
    public pmtMgrV1PaymentAgreementRetrieveGet(OrgId: number, ConsumerNumber: string, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentAgreementRetrieveInfo>>;
    public pmtMgrV1PaymentAgreementRetrieveGet(OrgId: number, ConsumerNumber: string, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentAgreementRetrieveInfo>>;
    public pmtMgrV1PaymentAgreementRetrieveGet(OrgId: number, ConsumerNumber: string, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentAgreementRetrieveGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentAgreementRetrieveGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<PaymentAgreementRetrieveInfo>(`${this.basePath}/PmtMgr/V1/PaymentAgreement/Retrieve`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_GetPaymentDetectNetwork, Detect payment network based on bin or routing number
     * Detect payment network
     * @param OrgId Enter the OrgId
     * @param CardNumber Enter the CardNumber
     * @param RoutingNumber Enter the Routing Number
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentDetectNetworkGet(OrgId: number, CardNumber?: string, RoutingNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<DetectNetworkResponse>;
    public pmtMgrV1PaymentDetectNetworkGet(OrgId: number, CardNumber?: string, RoutingNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DetectNetworkResponse>>;
    public pmtMgrV1PaymentDetectNetworkGet(OrgId: number, CardNumber?: string, RoutingNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DetectNetworkResponse>>;
    public pmtMgrV1PaymentDetectNetworkGet(OrgId: number, CardNumber?: string, RoutingNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentDetectNetworkGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (CardNumber !== undefined) {
            queryParameters = queryParameters.set('CardNumber', <any>CardNumber);
        }
        if (RoutingNumber !== undefined) {
            queryParameters = queryParameters.set('RoutingNumber', <any>RoutingNumber);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DetectNetworkResponse>(`${this.basePath}/PmtMgr/V1/Payment/DetectNetwork`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_GetPaymentInfo, Get the Payment Info based on TransactionId
     * Get the Payment Info based on TransactionId
     * @param OrgId Enter the OrgId
     * @param TransactionId Enter the TransactionId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentInfoGet(OrgId: number, TransactionId: number, observe?: 'body', reportProgress?: boolean): Observable<PaymentInfoResponseInfo>;
    public pmtMgrV1PaymentInfoGet(OrgId: number, TransactionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentInfoResponseInfo>>;
    public pmtMgrV1PaymentInfoGet(OrgId: number, TransactionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentInfoResponseInfo>>;
    public pmtMgrV1PaymentInfoGet(OrgId: number, TransactionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentInfoGet.');
        }
        if (TransactionId === null || TransactionId === undefined) {
            throw new Error('Required parameter TransactionId was null or undefined when calling pmtMgrV1PaymentInfoGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (TransactionId !== undefined) {
            queryParameters = queryParameters.set('TransactionId', <any>TransactionId);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<PaymentInfoResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Info`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentInquiry, Inquire a Payment
     * Inquire a Payment
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentInquiryRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PaymentInquiryResponseInfo>;
    public pmtMgrV1PaymentInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentInquiryRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentInquiryResponseInfo>>;
    public pmtMgrV1PaymentInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentInquiryRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentInquiryResponseInfo>>;
    public pmtMgrV1PaymentInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentInquiryRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentInquiryPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentInquiryPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentInquiryPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentInquiryResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Inquiry`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrievePmtMethod, Get the Payment Method based on Method
     * Get the Payment Method based on Method
     * @param Method Enter the Method needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentMethodGet(Method?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<PaymentMethodResponseInfo>;
    public pmtMgrV1PaymentMethodGet(Method?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentMethodResponseInfo>>;
    public pmtMgrV1PaymentMethodGet(Method?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentMethodResponseInfo>>;
    public pmtMgrV1PaymentMethodGet(Method?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Method) {
            Method.forEach((element) => {
                queryParameters = queryParameters.append('Method', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<PaymentMethodResponseInfo>(`${this.basePath}/PmtMgr/V1/PaymentMethod`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_NotificationReceipt, Notification Receipt
     * Notification Receipt
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the Consumer number
     * @param Request Enter the request values
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentNotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: NotificationReceiptRequestInfo, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<NotificationReceiptResponseInfo>;
    public pmtMgrV1PaymentNotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: NotificationReceiptRequestInfo, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationReceiptResponseInfo>>;
    public pmtMgrV1PaymentNotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: NotificationReceiptRequestInfo, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationReceiptResponseInfo>>;
    public pmtMgrV1PaymentNotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: NotificationReceiptRequestInfo, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentNotificationReceiptPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentNotificationReceiptPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentNotificationReceiptPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NotificationReceiptResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Notification/Receipt`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_NotificationSend, Send notification
     * Send notification
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the Consumer number
     * @param Request Enter the request values
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentNotificationSendPost(OrgId: number, ConsumerNumber: string, Request: NotificationSendRequestInfo, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<NotificationSendResponseInfo>;
    public pmtMgrV1PaymentNotificationSendPost(OrgId: number, ConsumerNumber: string, Request: NotificationSendRequestInfo, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationSendResponseInfo>>;
    public pmtMgrV1PaymentNotificationSendPost(OrgId: number, ConsumerNumber: string, Request: NotificationSendRequestInfo, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationSendResponseInfo>>;
    public pmtMgrV1PaymentNotificationSendPost(OrgId: number, ConsumerNumber: string, Request: NotificationSendRequestInfo, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentNotificationSendPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentNotificationSendPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentNotificationSendPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NotificationSendResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Notification/Send`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PmtMethodInquiry, Get the Allowed Payment Methods
     * Get the Allowed Payment Methods
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentPaymentMethodInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentMethodInquiryRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PaymentMethodInquiryResponseInfo>;
    public pmtMgrV1PaymentPaymentMethodInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentMethodInquiryRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentMethodInquiryResponseInfo>>;
    public pmtMgrV1PaymentPaymentMethodInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentMethodInquiryRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentMethodInquiryResponseInfo>>;
    public pmtMgrV1PaymentPaymentMethodInquiryPost(OrgId: number, ConsumerNumber: string, Request: PaymentMethodInquiryRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentPaymentMethodInquiryPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentPaymentMethodInquiryPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentPaymentMethodInquiryPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentMethodInquiryResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/PaymentMethod/Inquiry`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentPlanCalculator, ability To calculate the plan
     * Ability To calculate the plan
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter template specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentPlanCalculatorPost(OrgId: number, ConsumerNumber: string, Request: PaymentPlanCalCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<PaymentPlanCalCreateResponse>;
    public pmtMgrV1PaymentPlanCalculatorPost(OrgId: number, ConsumerNumber: string, Request: PaymentPlanCalCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentPlanCalCreateResponse>>;
    public pmtMgrV1PaymentPlanCalculatorPost(OrgId: number, ConsumerNumber: string, Request: PaymentPlanCalCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentPlanCalCreateResponse>>;
    public pmtMgrV1PaymentPlanCalculatorPost(OrgId: number, ConsumerNumber: string, Request: PaymentPlanCalCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentPlanCalculatorPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentPlanCalculatorPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentPlanCalculatorPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentPlanCalCreateResponse>(`${this.basePath}/PmtMgr/V1/Payment/Plan/Calculator`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_CancelPaymentPlan, Cancel a Payment Plan
     * Cancel a Payment Plan
     * @param OrgId Enter the OrgId
     * @param PlanId Enter the PlanId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentPlanPlanIdCancelPost(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request9, observe?: 'body', reportProgress?: boolean): Observable<PaymentPlanCancelResponse>;
    public pmtMgrV1PaymentPlanPlanIdCancelPost(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request9, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentPlanCancelResponse>>;
    public pmtMgrV1PaymentPlanPlanIdCancelPost(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request9, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentPlanCancelResponse>>;
    public pmtMgrV1PaymentPlanPlanIdCancelPost(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request9, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentPlanPlanIdCancelPost.');
        }
        if (PlanId === null || PlanId === undefined) {
            throw new Error('Required parameter PlanId was null or undefined when calling pmtMgrV1PaymentPlanPlanIdCancelPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentPlanPlanIdCancelPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentPlanPlanIdCancelPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentPlanCancelResponse>(`${this.basePath}/PmtMgr/V1/Payment/Plan/${encodeURIComponent(String(PlanId))}/Cancel`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_UpdatePaymentPlan, Update a Payment Plan
     * Update a Payment Plan
     * @param OrgId Enter the OrgId
     * @param PlanId Enter the PlanId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentPlanPlanIdPatch(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request8, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2009>;
    public pmtMgrV1PaymentPlanPlanIdPatch(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request8, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2009>>;
    public pmtMgrV1PaymentPlanPlanIdPatch(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request8, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2009>>;
    public pmtMgrV1PaymentPlanPlanIdPatch(OrgId: string, PlanId: string, ConsumerNumber: string, Request: Request8, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPatch.');
        }
        if (PlanId === null || PlanId === undefined) {
            throw new Error('Required parameter PlanId was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPatch.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPatch.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<InlineResponse2009>(`${this.basePath}/PmtMgr/V1/Payment/Plan/${encodeURIComponent(String(PlanId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RecreatePaymentPlan, Recreate a Payment Plan
     * Recreate a Payment Plan
     * @param OrgId Enter the OrgId
     * @param PlanId Enter the PlanId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentPlanPlanIdPut(OrgId: string, PlanId: number, ConsumerNumber: string, Request: Request7, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2008>;
    public pmtMgrV1PaymentPlanPlanIdPut(OrgId: string, PlanId: number, ConsumerNumber: string, Request: Request7, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2008>>;
    public pmtMgrV1PaymentPlanPlanIdPut(OrgId: string, PlanId: number, ConsumerNumber: string, Request: Request7, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2008>>;
    public pmtMgrV1PaymentPlanPlanIdPut(OrgId: string, PlanId: number, ConsumerNumber: string, Request: Request7, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPut.');
        }
        if (PlanId === null || PlanId === undefined) {
            throw new Error('Required parameter PlanId was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPut.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentPlanPlanIdPut.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<InlineResponse2008>(`${this.basePath}/PmtMgr/V1/Payment/Plan/${encodeURIComponent(String(PlanId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_Payment, Create a Payment
     * Create a Payment
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentPost(OrgId: number, ConsumerNumber: string, Request: PaymentRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PaymentResponseInfo>;
    public pmtMgrV1PaymentPost(OrgId: number, ConsumerNumber: string, Request: PaymentRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentResponseInfo>>;
    public pmtMgrV1PaymentPost(OrgId: number, ConsumerNumber: string, Request: PaymentRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentResponseInfo>>;
    public pmtMgrV1PaymentPost(OrgId: number, ConsumerNumber: string, Request: PaymentRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentProcess, Process the payment based on PlanId or TransactionId
     * Process the payment based on PlanId or TransactionId
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentProcessPost(OrgId: number, ConsumerNumber: string, Request: ProcessPaymentRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ProcessPaymentResponseInfo>;
    public pmtMgrV1PaymentProcessPost(OrgId: number, ConsumerNumber: string, Request: ProcessPaymentRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProcessPaymentResponseInfo>>;
    public pmtMgrV1PaymentProcessPost(OrgId: number, ConsumerNumber: string, Request: ProcessPaymentRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProcessPaymentResponseInfo>>;
    public pmtMgrV1PaymentProcessPost(OrgId: number, ConsumerNumber: string, Request: ProcessPaymentRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentProcessPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentProcessPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentProcessPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ProcessPaymentResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Process`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveTransactionHistory, Retrieve Transaction History
     * Retrieve Transaction History based on OrgId / GroupId and Payment method / Network / Card Type / AuthCode / Transaction status / Channel / Start Date time and End Date time.
     * @param StartDateTime Enter the StartDateTime for EventDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format
     * @param EndDateTime Enter the EndDateTime for EventDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format, Range between Start and EndateTime must be less than 30 days
     * @param OrgId Enter Org Id
     * @param GroupId Enter Group Id
     * @param PaymentMethod Enter the PaymentMethod. Allowed values are ACH, Cash, Card, Check
     * @param Network Enter the Network. Allowed values are Amex, Discover, Mastercard, Visa, DinersClub, JCB
     * @param AccountType Enter the Account type. Allowed values are Checking, Savings
     * @param AuthCode Enter the Authorization code.
     * @param TransactionId Enter Transaction Id.
     * @param TransactionStatus Enter the Transaction Status. Allowed values are Initiated, Approved, Voided, Refunded, Declined, Skipped, Accepted, Error, Returned, Adjusted
     * @param Channel Enter the Channel. Allowed values are InBoundIVR, OutboundIVR, LoggedInUser, QuickPay, ClientAdmin, RsAdmin, LockBox, Other
     * @param TimeZone Enter the Timezone. Allowed values are UTC, EST, CST, MST, PST, AKST, HST
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentQueryToolTransactionHistoryPost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PaymentMethod?: Array<string>, Network?: Array<string>, AccountType?: Array<string>, AuthCode?: string, TransactionId?: number, TransactionStatus?: Array<string>, Channel?: Array<string>, TimeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionHistoryResponseInfo>;
    public pmtMgrV1PaymentQueryToolTransactionHistoryPost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PaymentMethod?: Array<string>, Network?: Array<string>, AccountType?: Array<string>, AuthCode?: string, TransactionId?: number, TransactionStatus?: Array<string>, Channel?: Array<string>, TimeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionHistoryResponseInfo>>;
    public pmtMgrV1PaymentQueryToolTransactionHistoryPost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PaymentMethod?: Array<string>, Network?: Array<string>, AccountType?: Array<string>, AuthCode?: string, TransactionId?: number, TransactionStatus?: Array<string>, Channel?: Array<string>, TimeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionHistoryResponseInfo>>;
    public pmtMgrV1PaymentQueryToolTransactionHistoryPost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PaymentMethod?: Array<string>, Network?: Array<string>, AccountType?: Array<string>, AuthCode?: string, TransactionId?: number, TransactionStatus?: Array<string>, Channel?: Array<string>, TimeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (StartDateTime === null || StartDateTime === undefined) {
            throw new Error('Required parameter StartDateTime was null or undefined when calling pmtMgrV1PaymentQueryToolTransactionHistoryPost.');
        }
        if (EndDateTime === null || EndDateTime === undefined) {
            throw new Error('Required parameter EndDateTime was null or undefined when calling pmtMgrV1PaymentQueryToolTransactionHistoryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (OrgId) {
            OrgId.forEach((element) => {
                formParams = formParams.append('OrgId', <any>element) || formParams;
            })
        }
        if (GroupId) {
            GroupId.forEach((element) => {
                formParams = formParams.append('GroupId', <any>element) || formParams;
            })
        }
        if (PaymentMethod) {
            PaymentMethod.forEach((element) => {
                formParams = formParams.append('PaymentMethod', <any>element) || formParams;
            })
        }
        if (Network) {
            Network.forEach((element) => {
                formParams = formParams.append('Network', <any>element) || formParams;
            })
        }
        if (AccountType) {
            AccountType.forEach((element) => {
                formParams = formParams.append('AccountType', <any>element) || formParams;
            })
        }
        if (AuthCode !== undefined) {
            formParams = formParams.append('AuthCode', <any>AuthCode) || formParams;
        }
        if (TransactionId !== undefined) {
            formParams = formParams.append('TransactionId', <any>TransactionId) || formParams;
        }
        if (TransactionStatus) {
            TransactionStatus.forEach((element) => {
                formParams = formParams.append('TransactionStatus', <any>element) || formParams;
            })
        }
        if (Channel) {
            Channel.forEach((element) => {
                formParams = formParams.append('Channel', <any>element) || formParams;
            })
        }
        if (StartDateTime !== undefined) {
            formParams = formParams.append('StartDateTime', <any>StartDateTime) || formParams;
        }
        if (EndDateTime !== undefined) {
            formParams = formParams.append('EndDateTime', <any>EndDateTime) || formParams;
        }
        if (TimeZone !== undefined) {
            formParams = formParams.append('TimeZone', <any>TimeZone) || formParams;
        }

        return this.httpClient.post<TransactionHistoryResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/QueryTool/TransactionHistory`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveUpcomingSchedule, Retrieve Upcoming Schedule
     * Retrieve Scheduled Payments History based on OrgId / GroupId and Plan Type / Reference Number / Start Date time and End Date time.
     * @param StartDateTime Enter the StartDateTime for EventDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format
     * @param EndDateTime Enter the EndDateTime for EventDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format, Range between Start and EndateTime must be greater than 30 days
     * @param OrgId Enter Org Id
     * @param GroupId Enter Group Id
     * @param PlanType Enter the PlanType. Allowed values are OneTime, Recurring, Subscription , OneTimeFuture
     * @param ReferenceNumber Enter Reference number
     * @param TimeZone Enter the Timezone. Allowed values are UTC, EST, CST, MST, PST, AKST, HST
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentQueryToolUpcomingSchedulePost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PlanType?: Array<string>, ReferenceNumber?: string, TimeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<UpcomingScheduleRetrieveResponseInfo>;
    public pmtMgrV1PaymentQueryToolUpcomingSchedulePost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PlanType?: Array<string>, ReferenceNumber?: string, TimeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UpcomingScheduleRetrieveResponseInfo>>;
    public pmtMgrV1PaymentQueryToolUpcomingSchedulePost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PlanType?: Array<string>, ReferenceNumber?: string, TimeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UpcomingScheduleRetrieveResponseInfo>>;
    public pmtMgrV1PaymentQueryToolUpcomingSchedulePost(StartDateTime: string, EndDateTime: string, OrgId?: Array<number>, GroupId?: Array<number>, PlanType?: Array<string>, ReferenceNumber?: string, TimeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (StartDateTime === null || StartDateTime === undefined) {
            throw new Error('Required parameter StartDateTime was null or undefined when calling pmtMgrV1PaymentQueryToolUpcomingSchedulePost.');
        }
        if (EndDateTime === null || EndDateTime === undefined) {
            throw new Error('Required parameter EndDateTime was null or undefined when calling pmtMgrV1PaymentQueryToolUpcomingSchedulePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (OrgId) {
            OrgId.forEach((element) => {
                formParams = formParams.append('OrgId', <any>element) || formParams;
            })
        }
        if (GroupId) {
            GroupId.forEach((element) => {
                formParams = formParams.append('GroupId', <any>element) || formParams;
            })
        }
        if (PlanType) {
            PlanType.forEach((element) => {
                formParams = formParams.append('PlanType', <any>element) || formParams;
            })
        }
        if (ReferenceNumber !== undefined) {
            formParams = formParams.append('ReferenceNumber', <any>ReferenceNumber) || formParams;
        }
        if (StartDateTime !== undefined) {
            formParams = formParams.append('StartDateTime', <any>StartDateTime) || formParams;
        }
        if (EndDateTime !== undefined) {
            formParams = formParams.append('EndDateTime', <any>EndDateTime) || formParams;
        }
        if (TimeZone !== undefined) {
            formParams = formParams.append('TimeZone', <any>TimeZone) || formParams;
        }

        return this.httpClient.post<UpcomingScheduleRetrieveResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/QueryTool/UpcomingSchedule`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentRetry, Retry Payments
     * Retry a list of payments
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentRetryPost(OrgId: number, ConsumerNumber: string, Request: PaymentRetryRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PaymentRetryResponseInfo>;
    public pmtMgrV1PaymentRetryPost(OrgId: number, ConsumerNumber: string, Request: PaymentRetryRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentRetryResponseInfo>>;
    public pmtMgrV1PaymentRetryPost(OrgId: number, ConsumerNumber: string, Request: PaymentRetryRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentRetryResponseInfo>>;
    public pmtMgrV1PaymentRetryPost(OrgId: number, ConsumerNumber: string, Request: PaymentRetryRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentRetryPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentRetryPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentRetryPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentRetryResponseInfo>(`${this.basePath}/PmtMgr/V1/Payment/Retry`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_PaymentTransactionInquiry, Get the Bundle Transaction Info
     * Get the Bundle Transaction Info
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param BundleTransactionId Enter the BundleTransactionId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentTransactionInquiryGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionResponse>;
    public pmtMgrV1PaymentTransactionInquiryGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionResponse>>;
    public pmtMgrV1PaymentTransactionInquiryGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionResponse>>;
    public pmtMgrV1PaymentTransactionInquiryGet(OrgId: number, ConsumerNumber: string, BundleTransactionId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentTransactionInquiryGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentTransactionInquiryGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (BundleTransactionId !== undefined && BundleTransactionId !== null) {
            headers = headers.set('BundleTransactionId', String(BundleTransactionId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<TransactionResponse>(`${this.basePath}/PmtMgr/V1/Payment/Transaction/Inquiry`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveWallet, Get the Wallet Info based ConsumerNumber
     * Get the Wallet Info based on ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentWalletGet(OrgId: number, ConsumerNumber: string, observe?: 'body', reportProgress?: boolean): Observable<WalletRetrieveResponse>;
    public pmtMgrV1PaymentWalletGet(OrgId: number, ConsumerNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletRetrieveResponse>>;
    public pmtMgrV1PaymentWalletGet(OrgId: number, ConsumerNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletRetrieveResponse>>;
    public pmtMgrV1PaymentWalletGet(OrgId: number, ConsumerNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentWalletGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentWalletGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<WalletRetrieveResponse>(`${this.basePath}/PmtMgr/V1/Payment/Wallet`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_DeleteWallet, Delete the Wallet Info based on Id
     * Get the Wallet Info based on Id
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Id Enter the Wallet Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentWalletIdDelete(OrgId: number, ConsumerNumber: string, Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pmtMgrV1PaymentWalletIdDelete(OrgId: number, ConsumerNumber: string, Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pmtMgrV1PaymentWalletIdDelete(OrgId: number, ConsumerNumber: string, Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pmtMgrV1PaymentWalletIdDelete(OrgId: number, ConsumerNumber: string, Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentWalletIdDelete.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentWalletIdDelete.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling pmtMgrV1PaymentWalletIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/PmtMgr/V1/Payment/Wallet/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_RetrieveWalletById, Get the Wallet Info based ConsumerNumber
     * Get the Wallet Info based on ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Id Enter the Wallet Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentWalletIdGet(OrgId: number, ConsumerNumber: string, Id: number, observe?: 'body', reportProgress?: boolean): Observable<WalletGetResponse>;
    public pmtMgrV1PaymentWalletIdGet(OrgId: number, ConsumerNumber: string, Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletGetResponse>>;
    public pmtMgrV1PaymentWalletIdGet(OrgId: number, ConsumerNumber: string, Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletGetResponse>>;
    public pmtMgrV1PaymentWalletIdGet(OrgId: number, ConsumerNumber: string, Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentWalletIdGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentWalletIdGet.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling pmtMgrV1PaymentWalletIdGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<WalletGetResponse>(`${this.basePath}/PmtMgr/V1/Payment/Wallet/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_UpdateWallet, Update a Wallet
     * Update a Wallet
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Id Enter the Wallet Id
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentWalletIdPatch(OrgId: number, ConsumerNumber: string, Id: number, Request: WalletUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<WalletUpdateResponse>;
    public pmtMgrV1PaymentWalletIdPatch(OrgId: number, ConsumerNumber: string, Id: number, Request: WalletUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletUpdateResponse>>;
    public pmtMgrV1PaymentWalletIdPatch(OrgId: number, ConsumerNumber: string, Id: number, Request: WalletUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletUpdateResponse>>;
    public pmtMgrV1PaymentWalletIdPatch(OrgId: number, ConsumerNumber: string, Id: number, Request: WalletUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentWalletIdPatch.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentWalletIdPatch.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling pmtMgrV1PaymentWalletIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentWalletIdPatch.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<WalletUpdateResponse>(`${this.basePath}/PmtMgr/V1/Payment/Wallet/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtMgr_CreateWallet, Create a Wallet
     * Create a Wallet
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtMgrV1PaymentWalletPost(OrgId: number, ConsumerNumber: string, Request: WalletCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<WalletCreateResponse>;
    public pmtMgrV1PaymentWalletPost(OrgId: number, ConsumerNumber: string, Request: WalletCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletCreateResponse>>;
    public pmtMgrV1PaymentWalletPost(OrgId: number, ConsumerNumber: string, Request: WalletCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletCreateResponse>>;
    public pmtMgrV1PaymentWalletPost(OrgId: number, ConsumerNumber: string, Request: WalletCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling pmtMgrV1PaymentWalletPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling pmtMgrV1PaymentWalletPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtMgrV1PaymentWalletPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<WalletCreateResponse>(`${this.basePath}/PmtMgr/V1/Payment/Wallet`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
